export const TipoCarreta = [
  'Rodotrem',
  'Bitrem',
  'Carreta 4 Eixo',
  'Vanderleia',
  'Romeu e Julieta',
  '6 Eixos',
  'Caminhão Simples',
  'Caminhão Trucado',
  'Caminhão',
];

export enum TipoCarretaValueEnum {
  'Rodotrem' = 'RT',
  'Bitrem' = 'BT',
  'Carreta 4 Eixo' = '4E',
  'Vanderleia' = 'VL',
  'Romeu e Julieta' = 'RJ',
  '6 Eixos' = '6E',
  'Caminhão Simples' = 'CS',
  'Caminhão Trucado' = 'CT',
  'Caminhão' = 'CM',
}
